export enum SeverityLevel {
    Critical = 1,
    High = 2,
    Medium = 3,
    OnTrack = 4,
    OverRepresented = 5,
}

export enum DemographicGroup {
    African_Male = 'African Male',
    African_Female = 'African Female',
    Coloured_Male = 'Coloured Male',
    Coloured_Female = 'Coloured Female',
    Indian_Male = 'Indian Male',
    Indian_Female = 'Indian Female',
    White_Male = 'White Male',
    White_Female = 'White Female',
    Foreign_National_Male = 'Foreign National Male',
    Foreign_National_Female = 'Foreign National Female',
}

export enum WorkForceGoalAndTargetRow{
    BaselineSnapshot = 0,
    Actual = 1,
    ActualHeadcountAcheived = 2,
    EapTargetPercentage = 3,
    EapGapPercentage = 4,
    EapTargetHeadcount = 5,
    EapGapHeadcount = 6,
    SectoralTargetPercentage = 7,
    SectoralGapPercentage = 8,
    SectoralTargetHeadcount = 9,
    SectoralGapHeadcount = 10,
    Year_One = 11,
    YearOneHeadcountAcheived = 12,
    Year_Two = 13,
    YearTwoHeadcountAcheived = 14,
    Year_Three = 15,
    YearThreeHeadcountAchieved = 16,
    Year_Four = 17,
    YearFourHeadcountAchieved = 18,
    Goal_Year_Five = 19,
    GoalYearFiveHeadcountAchieved = 20
}

export enum EEOccupationalLevel {
    Unspecified = 0,
    Top_Management = 1,
    Senior_Management = 2,
    Middle_Management = 3,
    Junior_Management = 4,
    Semi_Skilled = 5,
    Unskilled = 6,
    Temporary = 7
}
 export enum CommitteeType
 {
     Forum = 1,
     Trade_Union = 2,
     All_Employees = 3,
 }

 export enum CommitteeMinutesAgenda
 {
    Opening_and_welcome = 1,
    Attendance_register = 2,
    EE_Reports_Review = 3,
    Monitoring_and_Evaluation_Feedback_from_Committee_Members_per_level = 4,
    Committee_Constitution_Review_and_Sign_off = 5,
    Barriers_Analysis = 6,
    Numerical_Analysis = 7,
    EE_Plan_Development_Communication_and_Review = 8,
    Quarterly_Review = 9,
    EE_Report_Review_presubmission  = 10,
    General = 11,
    Closing_and_date_for_next_meeting = 12,
    Other = 13

 }

 export enum EESectoralTargetYears
{
    Draft_Targets_2023 = 1,
    Draft_Targets_2024 = 2,
    Final_Targets_2025 = 3
}

export enum DeviationAuditPositionTypes {
    NewPosition = 1,
    Replacement = 2,
    Temporary = 3,
    Contract = 4,
}

export enum CandidateTimeToAcquireCompetencies {
    OneToThreeMonths = 1,
    SixToTwelveMonths = 2,
    TwelveMonthsOrLonger = 3,
}

export enum PlanSummaryMovementType {
    Recruited = 1,
    PromotedIn = 2,
    PromotedOut = 3,
    Terminated = 4,
}